import type { API } from 'chessboard/api/config/types';
import JCE from '@chesscom/js-chess-engine';

/**
 * Create the getTCN method.
 */
export function createGetTCN(context: API.Context) {
  /**
   * Get the TCN of a game.
   */
  return function getTCN(): string {
    const { game } = context;

    return JCE.encodeTCN(game.history(true));
  };
}
